
    export default {
      mounted() {
        const els = this.el.querySelectorAll(".landing-reveal")
        if (!("IntersectionObserver" in window)) return
        this.el.classList.add("js")
        const io = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting) {
                entry.target.classList.add("is-revealed")
                io.unobserve(entry.target)
              }
            }
          },
          { threshold: 0.15 }
        )
        els.forEach((el) => io.observe(el))
      }
    }
  